/**
 * CAD object metadata keys linking to a backend feature.
 * Written together via {@link stampFeatureLink} on ingest and after persist.
 */
export const CAD_FEATURE_ID_KEY = 'cadFeatureId';
export const CAD_SOURCE_FEATURE_KEY = 'cadSourceFeature';

/**
 * Cached backend feature snapshot for optimistic updates.
 * `id` is optional until the first successful create.
 */
export interface CachedSourceFeature {
  id?: string;
  geometry: { type: string; coordinates: unknown };
  properties: Record<string, unknown>;
  metadata?: Record<string, unknown>;
}

/** Stamp feature id + source snapshot so ingest/persist cannot drift. */
export function stampFeatureLink(
  metaData: Record<string, unknown>,
  featureId: string,
  sourceFeature: CachedSourceFeature
): void {
  metaData[CAD_FEATURE_ID_KEY] = featureId;
  metaData[CAD_SOURCE_FEATURE_KEY] = sourceFeature;
}
